export default "<template>\n\n  <KBreadcrumbs :items=\"[{ text: 'Home', link: null }]\" />\n\n</template>\n";